import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Controller, useFormContext } from "react-hook-form";

import { Select, OptionItem } from "@transfr-inc/dashboard-components/forms";
import { RequiredItem } from "@transfr-inc/dashboard-components";

import "./org-disciplines.editor.scss";

export const getProgramsOptions = (data) =>
  data?.map(
    (d) => new OptionItem({ id: d.id, text: d.name ?? d.title, data: d })
  );

const defaultPlaceholder =
  "Select one or more programs for this organization...";

export function OrgProgramsEditor({
  data,
  placeholder,
  className,
  name = "programs",
  required = false,
}) {
  const fieldTitle = "Programs";
  const [options, setOptions] = useState();
  const { control, resetField } = useFormContext();

  useEffect(() => {
    setOptions(getProgramsOptions(data));
  }, [data]);

  useEffect(() => {
    resetField(name);
  }, []);

  return (
    <div className={clsx("editor-section", className)}>
      <div className="section-title">
        <h2>{required ? <RequiredItem text={fieldTitle} /> : fieldTitle}</h2>
      </div>
      <Controller
        control={control}
        rules={{
          required,
        }}
        name={name}
        render={({ field: { value, onChange } }) => {
          return (
            <Select
              selected={value ?? []}
              placeholder={placeholder ?? defaultPlaceholder}
              icon={["fa-light", "fa-objects-column"]}
              onOptionsChange={onChange}
              className={"product-select"}
              options={options}
              searchEnabled
            ></Select>
          );
        }}
      />
    </div>
  );
}
